<template>
  <main class="main" role="main">
    <div class="main__inner bg"><!-- 배경: bg-->
      <div class="main__con">
        <div class="line"></div>
        <div class="used-wrap">
          <h5>사용량 내역</h5>
          <div class="table-wrap">
            <table class="table">
              <thead>
              <tr>
                <th colspan="2">고객번호</th>
                <td colspan="2" class="text-center">{{ assetData.customerNumber1 }}</td>
              </tr>
              </thead>
              <tbody>
              <tr>
                <th colspan="2" rowspan="2">계약전력</th>
                <th>기존</th>
                <th>변경</th>
              </tr>
              <tr>
                <td class="text-right p16">{{ assetData.currentPower }} kw</td>
                <td class="text-right p16">{{ assetData.recondPower }} kw</td>
              </tr>
              <tr>
                <th colspan="2">사용량</th>
                <td colspan="2" class="text-center">{{ $Util.formatNumber(assetData.usage) }}</td>
              </tr>
              <tr>
                <th colspan="2">사용기간</th>
                <td colspan="2" class="text-center">
                  {{ `${$moment(assetData.startUseDate1).format('YYYY.MM.DD')} ~ ${$moment(assetData.endUseDate1).format('YYYY.MM.DD')}` }}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="detail-wrap">
          <h5>절감 세부 내역</h5>
          <div class="table-wrap">
            <table class="table">
              <thead>
              <tr>
                <th class="detail-title">구분</th>
                <th class="detail-title">컨설팅 전</th>
                <th class="detail-title">컨설팅 후</th>
              </tr>
              </thead>
              <tbody>
              <tr class="highlight">
                <th class="detail-title">기본요금</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.beforeBasic) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterBasic1) }}</td>
              </tr>
              <tr class="highlight-sub">
                <th class="detail-title">전력량 요금</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterTotalLoad1) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterTotalLoad1) }}</td>
              </tr>
              <tr>
              <tr>
                <th class="detail-title">기후환경요금</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterClimate1) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterClimate1) }}</td>
              </tr>
              <tr>
                <th class="detail-title">연료비조정액</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterFuelAdjust1) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterFuelAdjust1) }}</td>
              </tr>
              <tr>
                <th class="detail-title">모바일 할인</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.mobileDiscount) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.mobileDiscount) }}</td>
              </tr>
              <tr>
                <th class="detail-title">전력기금</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterElectricFund1) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterElectricFund1) }}</td>
              </tr>
              <tr>
                <th class="detail-title">부가가치세</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterVat1) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterVat1) }}</td>
              </tr>
              <tr>
                <th class="detail-title">TV수신료</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterTvLicense1) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterTvLicense1) }}</td>
              </tr>
              <tr>
                <th class="detail-title">정산요금</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterAdjustPrice1) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterAdjustPrice1) }}</td>
              </tr>
              <tr>
                <th class="detail-title">연체료</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.lateFee) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.lateFee) }}</td>
              </tr>
              <tr>
                <th class="detail-title">가산금</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.addFee) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.addFee) }}</td>
              </tr>
              <tr>
                <th class="detail-title">원단위 절사</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterCutWon1) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterCutWon1) }}</td>
              </tr>
              <tr>
                <th class="detail-title">당월요금계</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterMonthBill1 + assetData.savePrice) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterMonthBill1) }}</td>
              </tr>
              <tr>
                <th class="detail-title">당월 청구요금</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterTotalBill1 + assetData.savePrice) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterTotalBill1) }}</td>
              </tr>
              <tr>
                <th colspan="2" class="detail-title">절감율</th>
                <td class="text-right number" colspan="2">{{ assetData.savePriceRate }}%</td>
              </tr>
              <tr>
                <th colspan="2" class="detail-title">절감액</th>
                <td class="text-right number" colspan="2">{{ $Util.formatNumber(assetData.savePrice) }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="detail-wrap">
          <h5>세부내역 차트</h5>
          <div class="table-wrap" style="border: #136599 solid 2px;">
            <report-bar-chart-low
              v-if="isReady"
              v-bind:assetData="assetData"
              v-bind:assetList="assetList" />
          </div>
        </div>

      </div>
    </div>
  </main>
</template>
<script>
import ReportBarChartLow from '@/components/chart/reportBarChartLow'

export default {
  components: {
    ReportBarChartLow
  },
  data: function () {
    return {
      isReady: false,
      customerType: 1,
      assetNo: this.$route.query.assetNo,
      assetYear: this.$route.query.assetYear,
      assetMonth: this.$route.query.assetMonth,
      assetData: {},
      assetList: [],
    }
  },
  created: function () {
    this.$EventBus.$emit('HeaderBar.setTitleName', `[${this.assetYear}년 ${this.assetMonth}월] 전기요금 컨설팅 보고서`)
    this.getAssetData()
    this.getAssetList()
  },
  beforeDestroy: function () {
    this.$EventBus.$emit('HeaderBar.setTitleName', '')
  },
  methods: {
    doFocus: function ($event) {
      if ($event.target.parentElement.className.indexOf('focus') >= 0) {
        $event.target.parentElement.setAttribute('class', '')
      } else {
        $event.target.parentElement.setAttribute('class', 'focus')
      }
    },
    getAssetList: async function () {
      const params = {
        userNo: this.$store.getters['account/getUserData'].userNo,
        page: 1,
        limit: 36
      }
      const res = await this.$AssetSvc.getAssetReportData(params)
      const code = res.code
      const message = res.message
      const entity = res.entity

      console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))

      if (code === 1) {
        this.assetList = entity.assetList
        this.isReady = true
      }
    },
    getAssetData: async function () {
      const res = await this.$AssetSvc.getAssetData({assetNo: this.assetNo})
      const code = res.code
      const message = res.message
      const entity = res.entity

      // console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))

      if (code === 1) {
        this.assetData = entity
        this.customerType = entity.customerType
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.used-wrap {
  padding: 1rem;
  background-color: white;
  box-shadow: 0 0 0.5rem 0 rgba(0, 0, 0, 0.5);
  white-space: nowrap;
  overflow-x: auto;
  font-size: 1.2rem;

  h5 {
    font-size: 1.4rem;
    font-weight: bold;
    color: #616161;
    margin-bottom: 1rem;
  }

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none;
  }

  .customer-type {
    text-align: right;
    margin-bottom: 0.2rem;
    font-weight: bold;
  }

  .table-wrap {
    width: 100%;

    &.twice {
      display: inline-block;
      width: 80%;

      &:last-child {
        margin-left: 1rem;
      }
    }

    .table {
      width: 100%;
      border: 1px solid #E6E6E6;

      th {
        border: 1px solid #E6E6E6;
        background-color: #EEEEEE;
      }

      td {
        border: 1px solid #E6E6E6;

        &.number {
          padding-right: 1rem;
        }
      }
    }
  }
}

.detail-wrap {
  padding: 1rem;
  margin-top: 1rem;
  background-color: white;
  font-size: 1.2rem;
  box-shadow: 0 0 0.5rem 0 rgba(0, 0, 0, 0.5);

  h5 {
    font-size: 1.4rem;
    font-weight: bold;
    margin-bottom: 1rem;
    color: #616161;
  }

  .table-wrap {
    width: 100%;
    white-space: nowrap;
    overflow-x: scroll;

    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none;
    }

    .table {
      width: 100%;
      border: 1px solid #E6E6E6;

      tr {
        background-color: white;
      }

      tr.highlight {
        td {
          font-size: 14px;
          font-weight: bold;
          padding: 3px 1rem 3px 3px;
        }
      }

      tr.highlight-sub {
        box-shadow: 10px 10px 10px 10px rgba(0, 0, 0, 0.5);
      }

      th {
        border: 1px solid #E6E6E6;
        background-color: #EEEEEE;
        padding-left: 1rem;
        padding-right: 1rem;

        &:not(.detail-title) {
          text-align: right;
        }
      }

      td {
        border: 1px solid #E6E6E6;
        text-align: right;
        padding-right: 1rem;

        &.number {
          padding-right: 1rem;
        }
      }
    }
  }
}
</style>
